import { useSelector as rawUseSelector, TypedUseSelectorHook } from 'react-redux';
import { RootState } from '../redux/store';
import { getCurrentCompanyUUID } from '../utils/utils';
import { appReducer } from '../redux/reducer';

export const useSelector: TypedUseSelectorHook<RootState> = (selectorFn) =>
    rawUseSelector((state: RootState) => {
        const companyUUID = getCurrentCompanyUUID();
        const companyState = state[companyUUID] ?? appReducer(undefined, { type: '@@INIT' });
        return selectorFn(companyState);
    });